module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_4-6708c2d4f1f0fa70ce0c26701ecf9d32.svg";